// we only need two breakpoints, mobile and desktop
const breakpoints = {
  sm: "62em",
  md: "62em",
  lg: "62em",
  xl: "80em",
  "2xl": "80em",
};

export default breakpoints;

// chakra defaults
// export const breakpoints = {
//   sm: "30em", // 480px
//   md: "48em", // 768px
//   lg: "62em", // 992px
//   xl: "80em", // 1280px
//   "2xl": "96em", // 1536px
// };
